import { format, sub, intervalToDuration } from 'date-fns';

export const date = new Date();

export const INTERVAL_KEY = 'interval';
export const DURATION_KEY = 'duration';

const DateTimeFormat = 'yyyy-MM-dd HH:mm:ss';

const CHART_AXIS_DATE_FORAMT = 'dd-MM-yy';

export const getCurrentTime = () => format(new Date(), DateTimeFormat);

export const getForamttedDate = passedDate =>
    format(passedDate, DateTimeFormat);

export const getFormattedChartAxisDate = passedDate =>
    format(passedDate, CHART_AXIS_DATE_FORAMT);

export const getDateWithDifference = ({
    currentTime,
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
}) => {
    if (!currentTime) {
        return getCurrentTime();
    }
    const diff = sub(new Date(currentTime), {
        years,
        months,
        weeks,
        days,
        hours,
        minutes,
        seconds,
    });
    return format(diff, DateTimeFormat);
};

export const INTERVALS = [
    { label: 'Off', value: 0 },
    { label: '5s', value: 5000 },
    { label: '10s', value: 10000 },
    { label: '30s', value: 30000 },
    { label: '1m', value: 60000 },
    { label: '5m', value: 300000 },
    { label: '15m', value: 900000 },
    { label: '30m', value: 1800000 },
    { label: '1h', value: 3600000 },
    { label: '2h', value: 7200000 },
    { label: '1d', value: 86400000 },
];

export const TIME_OPTIONS = [
    { label: 'Last 5 seconds', value: { seconds: 5 } },
    { label: 'Last 10 seconds', value: { seconds: 10 } },
    { label: 'Last 30 seconds', value: { seconds: 30 } },
    { label: 'Last 1 minutes', value: { minutes: 1 } },
    { label: 'Last 5 minutes', value: { minutes: 5 } },
    { label: 'Last 10 minutes', value: { minutes: 10 } },
    { label: 'Last 15 minutes', value: { minutes: 15 } },
    { label: 'Last 30 minutes', value: { minutes: 30 } },
    { label: 'Last 1 hour', value: { hours: 1 } },
    { label: 'Last 3 hours', value: { hours: 3 } },
    { label: 'Last 6 hours', value: { hours: 6 } },
    { label: 'Last 12 hours', value: { hours: 12 } },
    { label: 'Last 24 hours', value: { hours: 24 } },
    { label: 'Last 2 days', value: { days: 2 } },
    { label: 'Last 7 days', value: { days: 7 } },
];

export const getLocalInterval = () => {
    const storage = localStorage.getItem(INTERVAL_KEY);
    return JSON.parse(storage);
};

export const getAxisIntervalType = value => {
    if (value) {
        const key = Object.keys(value)[0];
        const interval = key.charAt(0).toUpperCase() + key.slice(1);
        return interval;
    }
    return 'Days';
};

export const getAxisLabelFormat = value =>
    getAxisIntervalType(value) === 'Days' ? 'd-MM-yy hh:mm' : 'hh:mm';

export const PANEL_INTERVALS = [
    { label: '0s', value: 0 },
    { label: '5s', value: 5 },
    { label: '10s', value: 10 },
    { label: '30s', value: 30 },
    { label: '1m', value: 60 },
    { label: '5m', value: 300 },
    { label: '15m', value: 900 },
    { label: '30m', value: 1800 },
    { label: '1h', value: 3600 },
    { label: '2h', value: 7200 },
    { label: '3h', value: 10800 },
    { label: '4h', value: 14400 },
    { label: '5h', value: 18000 },
    { label: '12h', value: 43200 },
    { label: '1d', value: 86400 },
];

export const getDifferenceBetweenTwoDates = (start, end) =>
    intervalToDuration({
        start: new Date(start),
        end: new Date(end),
    });
